import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'react-tooltip';

// Import shared components
import { IconInfo } from '../../components';

import css from './FieldLabelTooltip.module.css';

/**
 * The field tooltip consisting of the label, info icon with hover over hint.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.iconClassName add more style rules to the info icon in addition to components own css.infoIcon
 * @param {string?} props.tooltipId The ID of the Tooltip element
 * @param {string?} props.fieldId The ID of the Field element
 * @param {string?} props.caption The label string of the field
 * @param {string?} props.text The tooltip text that appears on hover over the info icon
 * @returns {JSX.Element} SVG icon
 */
const FieldLabelTooltip = props => {
  const {
    rootClassName, className, iconClassName,
    tooltipId, fieldId, caption, text
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const iconClasses =
    iconClassName ? classNames(css.infoIcon, iconClassName) : css.infoIcon;

  return (
    <>
      {typeof window === 'object' ? <Tooltip id={tooltipId} /> : null}
      <div className={classes}>
        <div className={css.tooltipBlock}>
          <label htmlFor={fieldId}>{caption}</label>
          <IconInfo
            className={iconClasses}
            data-tooltip-id={tooltipId}
            data-tooltip-content={text}
            data-border={true}
            data-text-color={'black'}
            data-background-color={'white'}
            data-border-color={'darkgrey'}
            data-class={css.tooltipText}
            data-place={'bottom'}
          />
        </div>
      </div>
    </>
  );
};

export default FieldLabelTooltip;
